export default "__VITE_ASSET__XK_GCaqu__"